import { Heading, Icon } from '@zoom/components';
import { Kind as HeadingKind } from '@zoom/components/dist/Heading';
import { Kind as IconKind } from '@zoom/components/dist/Icon';
import classnames from 'classnames';
import React from 'react';

import { Values } from '../types';

const ICON_COLOR = '#d2dce1';

export const messageType = {
  error: 'error',
  info: 'information',
} as const;

interface FullSizeMessageProps {
  className?: string;
  description?: React.ReactNode;
  headline: string;
  headingKind?: HeadingKind;
  iconKind?: IconKind;
  type?: Values<typeof messageType>;
}

export const FullSizeMessage: React.FC<FullSizeMessageProps> = ({
  className,
  description,
  headline,
  headingKind = 'section' as HeadingKind,
  iconKind,
  type = messageType.info,
}) => (
  <div data-test-id="full-size-message" className={classnames('full-size-message__wrapper', className)}>
    {iconKind && <Icon kind={iconKind} size={55} color={ICON_COLOR} />}
    <Heading kind={headingKind}>
      <span className={`${type}-title`}>{headline}</span>
    </Heading>
    {description && <p className="full-size-message__description">{description}</p>}
  </div>
);
